import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance } from "../../axios/api"

export const getallqueries = createAsyncThunk('getallqueries', async ()=>{
    try{
        const url = 'get_quotes_list'
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const getsinglequery = createAsyncThunk('getsinglequery', async (values)=>{
    try{
        const url = 'getquery_details'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
export const getkam = createAsyncThunk('getkam', async ()=>{
    try{
        const url = 'get_kam'
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const bookflight = createAsyncThunk('bookflight', async (values)=>{
    try{
        const url = 'book_for_payment'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
export const bookingStart = createAsyncThunk('bookingStart', async (values)=>{
    try{
        const url = 'booking_start'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
export const bookingStartOcean = createAsyncThunk('bookingStartOcean', async (values)=>{
    try{
        const url = 'booking_start_ocean'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
export const getorderid = createAsyncThunk('getorderid', async (values)=>{
    try{
        const url = 'create_order'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})
export const verifytransaction = createAsyncThunk('verifytransaction', async (values)=>{
    try{
        const url = 'payment_verify_status'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

// DEPRECATED — do not dispatch. The payment_failure endpoint must never be
// called: every former call site (BookCargo, CashFreePaymentModal,
// NewBookingFlowContent, OceanMainRateCom/New) now handles a failed or
// cancelled payment purely client-side. Kept only so the export doesn't
// disappear from under anything still importing the slice.
export const paymentfailed = createAsyncThunk('paymentfailed', async (values)=>{
    try{
        const url = 'payment_failure'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

export const cancelbooking = createAsyncThunk('cancelbooking', async (values)=>{
    try{
        const url = 'bookingCancel'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

const initialState = {
    data:{},
    loading:false,
    deleteres:{},
    queryId : ''
}

const allQueriesSlice = createSlice({
    name : 'queriesslice',
    initialState,
    reducers:{
        savequeryid:(state,{payload})=>{
            state.queryId = payload
        }
    },
    extraReducers:(builder)=>{
        builder.addCase(getallqueries.pending,(state)=>{
            return {...state, loading:true}
        })
        builder.addCase(getallqueries.fulfilled,(state,{payload})=>{
            return {...state,loading:false, data:payload}
        })
        builder.addCase(cancelbooking.fulfilled,(state,{payload})=>{
            return {...state,loading:false, deleteres:payload}
        })
        builder.addCase(cancelbooking.rejected,(state,{payload})=>{
            return {...state,loading:false, deleteres:payload}
        })
    }
})
export const { savequeryid } = allQueriesSlice.actions
export const queriessate = state => state.queriessate
export const getqueryId = state => state.queriessate.queryId
export default allQueriesSlice.reducer